import styled from "@emotion/styled";
import { Button, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import ChangeRequestOverview from "./ChangeRequestScreens/ChangeRequestOverview";
import ChangeRequestMilestone from "./ChangeRequestScreens/ChangeRequestMilestone";
import ChangeRequestBudgets from "./ChangeRequestScreens/ChangeRequestBudgets";
import ChangeRequestReview from "./ChangeRequestScreens/ChangeRequestReview";
import ChangeRequestPayments from "./ChangeRequestScreens/ChangeRequestPayments";
import TimelineOverviewCR from "./ChangeRequestScreens/TimelineComponents/TimelineOverviewCR";
import TimelineMilestoneCR from "./ChangeRequestScreens/TimelineComponents/TimelineMilestoneCR";
import TimelineImpactReviewCR from "./ChangeRequestScreens/TimelineComponents/TimelineImpactReviewCR";
import DesignOverview from "./ChangeRequestScreens/DesignComponents/DesignOverview";
import DesignMilestones from "./ChangeRequestScreens/DesignComponents/DesignMilestones";
import DesignReviewImpact from "./ChangeRequestScreens/DesignComponents/DesignReviewImpact";
import { ReactComponent as LeftArrowIcon } from "../../../../assets/svg/LeftArrowIcon.svg";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Setting } from "../../../../utils/Setting";
import { toast } from "react-toastify";
import { getApiData } from "../../../../utils/APIHelper";
import ChangeRequestPayouts from "./ChangeRequestScreens/ChangeRequestPayouts";
import { CHANGE_REQUEST_STATUS } from "../../../../config/constants";
import Permission from "../../../../components/Permission";

const StyledTab = styled(Tab)(({ theme, selected }) => ({
  color: selected ? "#fff !important" : "#949DAA",
  backgroundColor: selected ? "#0d0d0d !important" : "#fff !important",
  border: "1px solid #d7d8d9",
  borderRadius: "10px",
  minHeight: "40px !important",
  fontWeight: 500,
  textTransform: "none",
  marginRight: "10px",
  padding: "4px 16px !important",
  fontFamily: "Inter Tight",
  "&:hover": {
    backgroundColor: selected ? "#0d0d0d" : "",
    color: !selected && "#000",
  },
  "&.Mui-disabled": {
    opacity: 0.7,
    cursor: "not-allowed !important",
    backgroundColor: "#f5f5f5 !important",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "transparent",
  },
}));

const tabs = [
  { id: 0, title: "Overview" },
  // { id: 1, title: "Milestones" },
  { id: 1, title: "Budgets" },
  // { id: 3, title: "Payments", disabled: true },
  { id: 2, title: "Payouts" },
  { id: 3, title: "Review" },
];

const timelineTabs = [
  { id: 0, title: "Overview" },
  { id: 1, title: "Milestones" },
  { id: 2, title: "Review Impact" },
];

const ChangeRequestTabs = ({ projectDetails }) => {
  const [searchQuery, setSearchQuery] = useSearchParams();
  const [loading, setLoading] = useState();
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [tabValue, seTabValue] = useState(0);
  const { id: projectId } = useParams();
  const changeId = searchQuery.get("change");
  const typeParam = searchQuery.get("type");
  const [loadingItems, setLoadingItems] = useState([]);

  const isTimeline = typeParam === 'TIMELINE' || data?.type === 'TIMELINE';
  const isDesign = typeParam === 'DESIGN' || data?.type === 'DESIGN';
  const useChangelogThreeTabs = isTimeline || isDesign;
  const activeTabs = useChangelogThreeTabs ? timelineTabs : tabs;

  const handleTabChange = (e, newTab) => {
    seTabValue(newTab);
  };

  const fetchDetails = async () => {
    try {
      setLoading(true);
      const useTimelineEndpoint =
        typeParam === 'TIMELINE' ||
        typeParam === 'DESIGN' ||
        data?.type === 'TIMELINE' ||
        data?.type === 'DESIGN';
      const endpoint = useTimelineEndpoint
        ? Setting.endpoints.changeRequest.timelineDetails(changeId)
        : Setting.endpoints.changeRequest.details(changeId);

      const responseData = await getApiData(
        endpoint,
        "GET",
        {},
        {},
        true
      );
      setData(responseData);
    } catch (err) {
      toast.error(err.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (changeId) {
      fetchDetails();
    }
  }, [changeId, typeParam]);

  const handleApproveClick = async (cr) => {
    setLoadingItems((prev) => [...prev, cr?.changeRequestId]);

    try {
      const data = await getApiData(
        Setting.endpoints.changeRequest.approve(
          cr?.changeRequestId
        ),
        "PUT",
        {},
        {},
        true
      );
      fetchDetails();
      toast.success("Change Request Approved");
    } catch (err) {
      toast.error(err.message || "Something went wrong!");
    } finally {
      setLoadingItems((prev) =>
        [...prev].filter((it) => it !== cr?.changeRequestId)
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 4,
        // alignItems: "start",
      }}
    >
      <span style={{ marginBottom: "10px", fontWeight: "600" }}>
        Change Request
      </span>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flex: 1,
          marginBottom: "0 !important"
        }}
      >
        <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
          <LeftArrowIcon
            onClick={() =>
              navigate(`/project/details/${projectId}/change-request`)
            }
            style={{ cursor: "pointer", marginRight: "1vw" }}
          />
          <Tabs
            value={tabValue}
            variant="scrollable"
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { display: "none", marginBottom: 0 },
            }}
          >
            {activeTabs.map((tab, index) => (
              <StyledTab
                key={tab.id}
                label={tab.title}
                selected={tabValue === index}
                disabled={tab?.disabled}
              />
            ))}
          </Tabs>
        </div>
        {data?.status ===
          CHANGE_REQUEST_STATUS?.AWAITING_CONTRACTOR_CONFIRMATION && (
            <Permission resource="CHANGE_REQUESTS" action="UPDATE">
              <Button
                onClick={() => handleApproveClick(data)}
                variant="contained"
                color="primary"
                disabled={loadingItems?.includes(
                  data?.changeRequestId
                )}
              >
                Approve
              </Button>
            </Permission>
          )}
      </div>

      {!useChangelogThreeTabs && tabValue === 0 && (
        <ChangeRequestOverview data={data} projectDetails={projectDetails} />
      )}
      {!useChangelogThreeTabs && tabValue === 1 && <ChangeRequestBudgets data={data} />}
      {!useChangelogThreeTabs && tabValue === 2 && <ChangeRequestPayouts data={data} />}
      {!useChangelogThreeTabs && tabValue === 3 && (
        <ChangeRequestReview data={data} projectDetails={projectDetails} />
      )}

      {useChangelogThreeTabs && !isDesign && tabValue === 0 && <TimelineOverviewCR data={data} />}
      {useChangelogThreeTabs && isDesign && tabValue === 0 && <DesignOverview data={data} />}

      {useChangelogThreeTabs && !isDesign && tabValue === 1 && <TimelineMilestoneCR data={data} />}
      {useChangelogThreeTabs && isDesign && tabValue === 1 && <DesignMilestones data={data} />}

      {useChangelogThreeTabs && !isDesign && tabValue === 2 && <TimelineImpactReviewCR />}
      {useChangelogThreeTabs && isDesign && tabValue === 2 && <DesignReviewImpact data={data} />}
    </div>
  );
};

export default ChangeRequestTabs;
